<template>
  <Dialog
    v-on="$listeners"
    v-bind="$attrs"
    :title="locale.prizeHistory"
    :hasDecor="false"
  >
    <template v-if="records.length">
      <h3>{{ locale.uid }}: {{ uid }}</h3>
      <p>{{ locale.viaInGameMail }}</p>
      <div class="table">
        <div class="thead">
          <div class="row">
            <div class="col">{{ locale.prizeName }}</div>
            <div class="col">{{ locale.time }}</div>
          </div>
        </div>
        <div class="tbody">
          <div class="row" v-for="(item, idx) of records" :key="idx">
            <div class="col">amazon card ${{ item.money }}</div>
            <div class="col">{{ item.created_at | adFormatTime }}</div>
          </div>
        </div>
      </div>
    </template>
    <p class="not-won" v-else>{{ locale.notWonAnyPrizes }}</p>
  </Dialog>
</template>

<script>
import Dialog from "./dlg.vue";

export default {
  name: "RecordsDialog",
  props: ["uid"],
  components: {
    Dialog,
  },
  data() {
    return {
      locale: this.$locale.dialog.records,
      records:
        [] ||
        Array.from({ length: 5 }, (_, idx) => {
          return {
            name: "lorem_" + idx,
            time: "2023-06-28",
          };
        }),
    };
  },
  created() {},
  watch: {
    "$attrs.visible"(val) {
      if (val) {
        this.getRecords();
      }
    },
  },
  mounted() {},
  computed: {},
  methods: {
    getRecords() {
      this.$req.getRecords().then((res) => {
        this.records = res.data?.items || [];
      });
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep {
  .dialog-body {
    padding: 40px;
    min-height: 360px;
  }
}

h3,
p {
  font-size: 24px;
  color: #fff;
  text-align: center;
}

h3 {
  margin-bottom: 10px;
}

p {
  margin-bottom: 20px;
}

.not-won {
  margin: 100px 0;
  color: var(--primary-color);
}

@border-color: #8e683e;
@border: 1px solid @border-color;
@cell-height: 46px;

.table {
  width: 90%;
  height: auto;
  border-radius: 8px;
  overflow: hidden;
  background: #744f23;
  border: @border;

  .row {
    margin: 0;
    border-radius: 0;
  }

  .col {
    flex: 1;
    font-size: 22px;
    color: #eee;
    font-weight: normal;
  }

  .thead {
    height: @cell-height;
    background-color: #482d1b;
    border-bottom: @border;

    .row {
    }

    .col {
      &:not(:last-child) {
        border-right: @border;
      }

      &::after {
        content: none;
      }
    }
  }

  .tbody {
    padding: 0;
    background-color: #744f23;

    .row {
      height: @cell-height;

      &:not(:last-child) {
        border-bottom: @border;
      }
    }
    .col {
      line-height: @cell-height;

      &:not(:last-child) {
        border-right: @border;
      }

      &::after {
        content: none;
      }
    }
  }
}
</style>
